import { useEffect } from 'react';

import type { LobbyView } from '@sunflower-games/analytics-events';

import { resetImpressionView } from '../seenGamesImpression';

// Starts a new impression view when the view or its category changes; call it before `useGamesSeen`.
// `trigger` is the category the player is in: 'all' on the home lobby, 'search', or the filter's name.
export function useImpressionView(view: LobbyView, trigger: string, viewKey = '') {
  useEffect(() => {
    resetImpressionView(view, trigger);
  }, [view, trigger, viewKey]);
}
